import { PageHero, SectionHead, Reveal, usePageMeta } from "@/components/primitives";
import { ImpactTargets, BharatSection, FinalCTA } from "@/components/blocks2";

export default function Impact() {
  usePageMeta(
    "TimePe Impact | Expanding Financial Access Across Bharat",
    "TimePe's impact vision: a target network of 50,000+ agents and retailers, long-term reach of 1M+ individuals, and Tier 2–6 priority markets."
  );
  return (
    <>
      <PageHero
        eyebrow="Impact"
        lines={["Expanding Access.", "Building Trust."]}
        lead="Our impact goals are stated as targets and vision — honestly labelled, and pursued with discipline."
      />
      <ImpactTargets />

      <section className="border-b border-line bg-abyss/50 py-24 sm:py-32" data-testid="impact-philosophy">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-2">
            <SectionHead
              eyebrow="Why It Matters"
              title="Inclusion Is an Infrastructure Problem"
              lead="Access to safe financial services shouldn't depend on where you live, what language you speak, or how comfortable you are with a smartphone."
            />
            <Reveal delay={0.1} className="space-y-5 text-base leading-relaxed text-mute">
              <p>
                Millions of users across Bharat still rely on assisted and agent-led financial services.
                TimePe's tech-plus-touch model treats agents, retailers and SHGs as first-class
                participants — extending digital finance into the real world rather than waiting for
                the real world to catch up.
              </p>
              <p>
                Every layer of the platform — multilingual experiences, assisted journeys, fraud
                protection — exists so that first-time and underserved users can participate in digital
                finance with confidence.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <BharatSection />
      <FinalCTA />
    </>
  );
}
